export default "__VITE_ASSET__Hhd8R5XI__"